export default function () {
    return {
        title: 'Spacer Widget',
        richTextMessage: '',
    }
}
